import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import toast from 'react-hot-toast';
import axios from 'axios';
import './AdminLogin.css';

const API = process.env.REACT_APP_API_URL || 'https://api.blood.msdiscoveries.com/api';

const AdminLogin = () => {
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [showPw, setShowPw] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('bb_admin_token');
    if (token) navigate('/admin/dashboard');
  }, [navigate]);

  const handleLogin = async (e) => {
    e.preventDefault();
    if (!password) { toast.error('Enter your password.'); return; }
    setLoading(true);
    try {
      const { data } = await axios.post(`${API}/auth/login`, { password });
      localStorage.setItem('bb_admin_token', data.token);
      toast.success('Welcome back, Admin!');
      navigate('/admin/dashboard');
    } catch (err) {
      toast.error(err.response?.data?.error || 'Invalid password.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Helmet>
        <title>Admin Login — BloodBridge</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <div className="admin-login-page">
        <div className="al-left">
          <div className="al-brand">
            <Link to="/" className="al-logo">
              <span className="al-logo-icon">
                <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
                  <path d="M12 2C12 2 5 9.5 5 14a7 7 0 0 0 14 0C19 9.5 12 2 12 2z"/>
                </svg>
              </span>
              BloodBridge
            </Link>
          </div>
          <div className="al-content">
            <div className="al-art">
              <svg viewBox="0 0 200 200" fill="none" className="al-svg">
                <circle cx="100" cy="100" r="80" stroke="rgba(255,255,255,0.06)" strokeWidth="1"/>
                <circle cx="100" cy="100" r="60" stroke="rgba(255,255,255,0.08)" strokeWidth="1"/>
                <circle cx="100" cy="100" r="40" stroke="rgba(255,255,255,0.1)" strokeWidth="1"/>
                <path d="M100 60 C100 60 75 85 75 100 a25 25 0 0 0 50 0 C125 85 100 60 100 60z"
                  fill="rgba(255,255,255,0.15)" stroke="rgba(255,255,255,0.3)" strokeWidth="1"/>
              </svg>
            </div>
            <h2>Admin Portal</h2>
            <p>Manage blood donor records, view statistics, and coordinate emergency requests from your secure dashboard.</p>
            <div className="al-features">
              <div className="al-feature">✓ Donor database management</div>
              <div className="al-feature">✓ Search & filter by blood group</div>
              <div className="al-feature">✓ Add, edit, delete donor records</div>
              <div className="al-feature">✓ View contact form submissions</div>
            </div>
          </div>
        </div>

        <div className="al-right">
          <div className="al-form-wrap">
            <div className="al-form-header">
              <div className="al-form-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" width="28" height="28">
                  <rect x="3" y="11" width="18" height="11" rx="2" ry="2"/>
                  <path d="M7 11V7a5 5 0 0 1 10 0v4"/>
                </svg>
              </div>
              <h1>Secure Login</h1>
              <p>Enter your administrator password to continue.</p>
            </div>

            <form onSubmit={handleLogin} className="al-form">
              <div className="form-group">
                <label className="form-label" htmlFor="pw">Admin Password</label>
                <div className="pw-input-wrap">
                  <input
                    id="pw"
                    type={showPw ? 'text' : 'password'}
                    className="form-input form-input-light al-pw-input"
                    placeholder="Enter password"
                    value={password}
                    onChange={e => setPassword(e.target.value)}
                    autoComplete="current-password"
                  />
                  <button type="button" className="pw-toggle" onClick={() => setShowPw(s => !s)}>
                    {showPw ? '🙈' : '👁️'}
                  </button>
                </div>
              </div>

              <button type="submit" className="btn btn-dark al-submit" disabled={loading}>
                {loading ? (
                  <><span className="al-spinner" />Authenticating...</>
                ) : (
                  <>Sign In</>
                )}
              </button>
            </form>

            <div className="al-back">
              <Link to="/">← Back to Website</Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AdminLogin;
